import { useDispatch } from "react-redux"
import { useGetLojaAtualQuery } from "@/api"
import { canalDoIdentificador } from "@/lib/canal"
import { useReconciliacaoCarrinho } from "@/lib/usar-reconciliacao-carrinho"
import { CarrinhoKiosk } from "@/pages/carrinho/kiosk"
import { irVista } from "./navegacao"

export default function Carrinho({ bloqueado }: { bloqueado: boolean }): JSX.Element {
    const dispatch = useDispatch()
    const { data: loja } = useGetLojaAtualQuery()
    const { alteracoes, descartarAviso } = useReconciliacaoCarrinho(
        loja ? canalDoIdentificador(loja.identificador) : 'CARDAPIO_TOTEM',
    )

    return (
        <CarrinhoKiosk
            bloqueado={bloqueado}
            alteracoes={alteracoes}
            aoDescartarAviso={descartarAviso}
            aoVoltar={() => irVista(dispatch, { currentView: 'VIEW_CATALOGO' })}
            aoFinalizar={() => irVista(dispatch, { currentView: 'VIEW_FINALIZAR' })}
        />
    )
}
